import React, { useRef } from 'react';
import styled from 'styled-components';
import CategoryItem from './CatetoryItem';

const Container = styled.div`
  flex-direction: row;
  width: 100%;
  overflow-x: scroll;
  white-space: nowrap;
  padding: 20px 5px 5px 20px;
  align-items: center;
  display: flex;
  background-color: #fff;

  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
    scrollbar-width: none;
    -ms-overflow-style: none;
    display: none;
  }
`;

export interface CategoryOption {
  value: string;
  name?: string;
  arabicName?: string;
}
interface Props {
  options: CategoryOption[];
  selectedOption?: CategoryOption;
  setSelectedOption?: (option: CategoryOption) => void;
  getName?: (option?: CategoryOption) => void;
}

const Categories: React.FC<Props> = ({
  options,
  selectedOption,
  setSelectedOption,
  getName,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <Container ref={containerRef}>
      {options.map((item, index) => {
        const isSelected = selectedOption?.value === item?.value;
        const key = `category-${index}`;

        return (
          <CategoryItem
            isSelected={isSelected}
            setSelectedOption={setSelectedOption}
            option={item}
            getName={getName}
            aria-label={item?.name}
            style={{
              backgroundColor: isSelected ? '#000' : '#fff',
              color: isSelected ? '#fff' : '#000',
            }}
            key={key}
            onClick={() => {
              setSelectedOption?.(item);
              console.log('client', containerRef.current?.offsetWidth);
            }}
          />
        );
      })}
    </Container>
  );
};

export default Categories;
